export const selectRole = (state) => state.role.rname;
